// extracted by mini-css-extract-plugin
export default {"inputWithEditButton":"InputWithEditButton_inputWithEditButton__UGyXj","spinner":"InputWithEditButton_spinner__VZLBq"};